import { Category } from "src/app/modules/shared/models/category.model";

class BaseProduct {
    id: number;
    name: string;
    logo: string;
    discount: string;
    varieties: any;
    currency: any;
    cashback: number;
    store_product_logo: string;
    store_product_name: string;
    isRelatedTarget: boolean;
    category: Category;

    constructor(id: number, name: string, logo: string, discount: string, varieties: any, currency: any, cashback: number, store_product_logo: string, store_product_name: string, isRelatedTarget: boolean, category: Category) {
      this.id = id;
      this.name = name;
      this.logo = logo;
      this.discount = discount;
      this.varieties = varieties;
      this.currency = currency;
      this.cashback = cashback;
      this.store_product_logo = store_product_logo;
      this.store_product_name = store_product_name;
      this.isRelatedTarget = isRelatedTarget;
      this.category = category;
    }
}
  
class SharedProduct extends BaseProduct {

  
    constructor(product: any, storeDetail: any) {
      const id = product.extra_info?.id;
      const name = product.title;
      const logo = product.image;
      const store_product_logo = product.extra_info?.store_product_logo;
      const store_product_name = product.extra_info?.store_product_name;
      const currency = product.extra_info?.currency_detail;
      const discount = product.extra_info?.discount;
      const varieties = [{ variety_detail: { min_price: product?.extra_info?.min_price, max_price: product?.extra_info?.max_price } }];
      const cashback = storeDetail?.has_cashback ? product?.extra_info?.cashback : 0;
      const isRelatedTarget = false;
      const category = product.extra_info?.category_detail;

      super(id, name, logo, discount, varieties, currency, cashback, store_product_logo, store_product_name, isRelatedTarget, category);
    }
}
  
class RelatedProduct extends BaseProduct {
    constructor(product: any, storeDetail: any) {
      const id = product.id;
      const name = product.store_product_detail?.name || product.name;
      const logo = product.store_product_detail?.logo || product.logo;
      const store_product_logo = product.store_product_detail?.logo;
      const store_product_name = product.store_product_detail?.name;
      const currency = product.currency_detail;
      const discount = product.store_product_detail?.discount;
      const varieties = [{ variety_detail: { min_price: product?.store_product_detail?.store_varieties[0]?.variety_detail?.min_price, max_price: product?.store_product_detail?.store_varieties[0]?.variety_detail?.max_price } }];
      const cashback = storeDetail?.has_cashback ? product.store_product_detail?.cashback : 0;
      const isRelatedTarget = false;
      const category = product.extra_info?.category_detail;

      super(id, name, logo, discount, varieties, currency, cashback, store_product_logo, store_product_name, isRelatedTarget, category);
    }
}

export { RelatedProduct, SharedProduct };